const GrupoConteudoNew = () =>
  import("~/components/Views/Prova/GrupoConteudo/New");
const GrupoConteudoList = () =>
  import("~/components/Views/Prova/GrupoConteudo/List");

import auth from "~/middleware/auth";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Configurações", link: "" }
];

export const grupoConteudo = [
  {
    path: "administracao/grupo-conteudo",
    component: GrupoConteudoList,
    name: "Grupo de Conteúdo",
    meta: {
      title: "Grupo de Conteúdo",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "administracao/grupo-conteudo/new",
    component: GrupoConteudoNew,
    name: "Novo Grupo de Conteúdo",
    meta: {
      title: "Novo Grupo de Conteúdo",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "administracao/grupo-conteudo/:grupoConteudo",
    component: GrupoConteudoNew,
    name: "Alterar Grupo de Conteúdo",
    meta: {
      title: "Alterar Grupo de Conteúdo",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/administracao/grupoConteudo.js